export default "__VITE_ASSET__Be1$BTg4__"